import React from 'react';

const Attractions = () => {
 const attractions = [
  {
    title: "Farm Stays",
    icon: "icon-flag",
    desc: "Enjoy a peaceful farm stay in eco-friendly huts and tents surrounded by lush greenery. Wake up to birdsong, explore nearby fields, and wind down with bonfires, storytelling, and stargazing under the open sky. A perfect escape from city life.",
  },
  {
    title: "Farm Experiences",
    icon: "icon-location-pin",
    desc: "Get hands-on with rural life! Join in crop harvesting, milk cows, pluck tamarind and custard apples, or water the fields. Children and adults alike enjoy these immersive and educational activities that connect you to nature and farming heritage.",
  },
  {
    title: "Tractor or Bullock Cart Ride",
    icon: "icon-directions",
    desc: "Hop onto a traditional bullock cart or a tractor and enjoy a guided tour of the village. These slow-paced rides are filled with scenic beauty, friendly waves from villagers, and tales of rural traditions shared by local guides.",
  },
  {
    title: "Hurda Party",
    icon: "icon-compass",
    desc: "Celebrate winter harvest with a traditional Hurda Party. Enjoy freshly roasted jowar seeds served with chutneys, followed by rural delicacies like Pithla-Bhakri and Zunka. Music, dance, and warm bonfires make it a truly memorable night.",
  },
  {
    title: "Traditional Maharashtrian Cooking Workshop",
    icon: "icon-fire",
    desc: "Join hands-on cooking sessions where you learn to prepare authentic Maharashtrian dishes using fresh farm produce. This workshop offers a flavorful dive into local culinary traditions, perfect for both kids and adults interested in food culture.",
  },
  {
    title: "Mango Mahotsav",
    icon: "icon-compass",
    desc: "Celebrate the king of fruits at our Mango Festival! Relish freshly plucked Alphonso and Kesar mangoes, enjoy fruit-based games and mango-eating contests. It's a juicy summer celebration packed with flavor, family fun, and cultural joy.",
  },
];


  return (
    <>
      <section
        className="breadcrumb-main pb-20 pt-14"
        style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}
      >
        <div
          className="section-shape section-shape1 top-inherit bottom-0"
          style={{ backgroundImage: 'url(images/shape8.png)' }}
        ></div>
        <div className="breadcrumb-outer">
          <div className="container">
            <div className="breadcrumb-content text-center">
              <h2 className="mb-3 text-white">Our Attractions</h2>
            </div>
          </div>
        </div>
        <div className="dot-overlay"></div>
      </section>

      <section className="about-us pb-0  bg-grn">
        <div
          className="section-shape section-shape1"
          style={{ backgroundImage: 'url(images/shape8.png)' }}
        ></div>
        <div className="container">
          <div className="mb-6 w-50 mx-auto text-center">
            <h4 className="mb-1 theme1 text-white">Explore Our Perfect Attractions</h4>
            <h2 className="mb-1">
              Unforgettable <span className="theme text-white">Experiences Await</span>
            </h2>
            <p className='text-white'>
              Explore the best of our agro-tourism resort, where culture, nature, and adventure blend for a truly local experience.
            </p>
          </div>

          <div className="why-us">
            <div className="why-us-box">
              <div className="row">
                {attractions.map((item, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-sm-6 mb-4">
                    <div
                      className="why-us-item p-5 pt-6 pb-6 border rounded bg-white h-100 d-flex flex-column justify-content-between"
                      style={{ minHeight: '380px' }}
                    >
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className={`${item.icon} theme`}></i>
                        </div>
                        <h4>
                          <a href="about.html">{item.title}</a>
                        </h4>
                        <p className="mb-0">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Attractions;
